import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@Redux/search/store';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { setTagList } from '@Redux/search/actions';
import { setAllSelected } from '@Redux/search/All/action';
import { setGroupSelected } from '@Redux/search/Group/action';
import { setHotelSelected } from '@Redux/search/Hotel/action';
import { setTicketSelected } from '@Redux/search/Ticket/action';
import { setVocationSelected } from '@Redux/search/Vacation/action';
import { setFlightSelected } from '@Redux/search/Flight/action';
import { useMediaQuery } from 'react-responsive';
import Lion from '@lion-design/icons';
import cN from 'classnames';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import FiltersWithSort from '@components/SearchPage/FiltersWithSort';
import createSearchPanel from '@utils/creaeteSearchPanel';
// import MenuSideBar from '@utils/MenuSideBar';
import * as Icons from '@components/Common/Icons';
import useDataLayer from 'src/hooks/useDataLayer';

import { changeSeoParams, getSessionStorageKeyVal } from '@utils/utils';
import 'normalize.css';
import './styles.scss';
import i18n from '@utils/i18n';

i18n();

declare global {
    interface Window {
        SearchPanel: any;
        Templates: {
            login_lion: {
                default: {
                    OpenLogin(): any;
                };
            };
        };
    }
}

const BACKGROUND = window.sessionStorage.getItem('BannerImg') || ''; //如果要帶圖這邊要傳物件需與搜尋面板確認
const imgProp = (() => {
    if (BACKGROUND) return JSON.parse(BACKGROUND); // 搜尋面版會以JSON物件傳出，但這邊如果拿到空字串或falsy則return，若為字串會爆錯要看拿到的值為何
    return { imgUrlM: null, imgUrl: null };
})();
const imgUrlM = imgProp.imgUrlM ? imgProp.imgUrlM : undefined; //拿背景圖並判斷是否有值
const imgUrl = imgProp.imgUrl ? imgProp.imgUrl : undefined;
const Kwop = window.sessionStorage.getItem('Kwop') || ''; //判斷是否隱藏搜尋框文字 1=不顯示；預設顯示
const KEYWORD = Kwop == '1' ? '' : window.sessionStorage.getItem('Keyword') || '';
const homePageHref = `https://${
    process.env.ENV === 'prod' ? '' : 'u'
}www.liontravel.com/category/zh-tw/index`;

// seo推廣網址用，針對taglist跟sort判斷有沒有值，有的話即為初始值
const seo_tagList = getSessionStorageKeyVal('TagList') || null;
let seo_sort = getSessionStorageKeyVal('Sort') || null;

const Search = () => {
    const moduleClass = 'search';
    const [sticky, setSticky] = useState<string>('');
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const dispatch = useDispatch();
    const bg = isMobile ? imgUrlM : imgUrl;
    const bgStyle = {
        //注意 背景圖pc跟m版呈現位置不一樣
        backgroundImage: bg ? `url(${bg}) ` : undefined,
    };
    const { favPopUp } = useSelector((state: RootState) => state.search.reducer);
    useDataLayer();

    // useEffect(() => {
    // jQuery 側邊欄啟動
    // MenuSideBar(jQuery);
    // }, []);
    // Mobile頁面往下捲依序變化:搜尋框header -> 換色的header -> filter，反捲則會呈現搜尋框
    useScrollPosition(({ prevPos, currPos }) => {
        if (!isMobile) return;
        if (currPos.y > -300) return setSticky('');
        if (prevPos.y < currPos.y && currPos.y < -300) return setSticky('searchPanel');
        if (prevPos.y > currPos.y && currPos.y < -300) return setSticky('filters');
    }, []);

    useEffect(() => {
        // 搜尋面板用參數
        createSearchPanel({
            keyword: KEYWORD,
            imgUrlM: imgUrlM || '',
            imgUrl: imgUrl || '',
        });
    }, []);

    useEffect(() => {
        //seo推廣網址的話會夾帶參數當作初始值,一般搜索進來的不改變，sort參數可參考FiltersWithSort.tsx的sortByOptions dropdown值
        // { 行銷用的參數表，但館別各自參數不太一樣要逐一比對，館別沒有的排序則給預設關聯度
        //     a: '依關聯度',
        //     b: '價格低到高',
        //     c: '價格高到低',
        //     d: '依出發日',
        //     e: '依天數',
        //     f: '熱門商品',
        //     g: '雄獅精選',
        //     h: '評分高優先',
        //     i: '最多人買',
        // };
        // if (seo_tagList) {}
        let sort;
        switch (seo_tagList) {
            case 'grp':
                switch (seo_sort) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'd':
                        sort = 3;
                        break;
                    case 'e':
                        sort = 4;
                        break;
                    case 'f':
                        sort = 8;
                        break;
                    default:
                        sort = '';
                        seo_sort = 'a'; //網址參數都不符則給預設
                        break;
                }
                changeSeoParams(seo_sort, 'grp');
                dispatch(setGroupSelected({ SortType: sort }));
                dispatch(setTagList(seo_tagList));
                break;
            case 'htl':
                switch (seo_sort) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    case 'f':
                        sort = 4;
                        break;
                    case 'g':
                        sort = 6;
                        break;
                    case 'h':
                        sort = 8;
                        break;
                    default:
                        sort = '';
                        seo_sort = 'a'; //網址參數都不符則給預設
                        break;
                }
                changeSeoParams(seo_sort, 'htl');
                dispatch(setHotelSelected({ SortType: sort }));
                dispatch(setTagList(seo_tagList));
                break;
            case 'vac':
                switch (seo_sort) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    case 'f':
                        sort = 4;
                        break;
                    case 'i':
                        sort = 6;
                        break;
                    case 'e':
                        sort = 7;
                        break;
                    default:
                        sort = '';
                        seo_sort = 'a'; //網址參數都不符則給預設
                        break;
                }
                changeSeoParams(seo_sort, 'vac');
                dispatch(setVocationSelected({ SortType: sort }));
                dispatch(setTagList(seo_tagList));
                break;
            case 'etk':
                switch (seo_sort) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    case 'f':
                        sort = 4;
                        break;
                    default:
                        sort = '';
                        seo_sort = 'a'; //網址參數都不符則給預設
                        break;
                }
                changeSeoParams(seo_sort, 'etk');
                dispatch(setTicketSelected({ SortType: sort }));
                dispatch(setTagList(seo_tagList));
                break;
            case 'flt':
                switch (seo_sort) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    case 'f':
                        sort = 4;
                        break;
                    default:
                        sort = '';
                        seo_sort = 'a'; //網址參數都不符則給預設
                        break;
                }
                changeSeoParams(seo_sort, 'flt');
                dispatch(setFlightSelected({ SortType: sort }));
                dispatch(setTagList(seo_tagList));
                break;
            // case null:
            // case undefined: //沒給值
            //     break;
            default:
                switch (seo_sort) {
                    case 'b':
                        sort = 1;
                        break;
                    case 'c':
                        sort = 2;
                        break;
                    default:
                        sort = '';
                        seo_sort = 'a'; //網址參數都不符則給預設
                        break;
                }
                changeSeoParams(seo_sort, seo_tagList); // 此fn只專門控制網址
                // dispatch裡的控制redux狀態，網址不一定會有參數或是參數亂給
                dispatch(setAllSelected({ SortType: sort }));

            // TODO 不知道為啥要加這個，檢查沒問題要刪掉
            // dispatch(setTagList('grp,vac,htl,etk'));
        }
    }, []);
    return (
        <div className={moduleClass} style={bgStyle}>
            <div
                id="sidebar_nion"
                className="pge_conl"
                data-sidebar-position="0"
                data-sidebar-icon-favorite="true"
                data-sidebar-icon-history="false"
                data-sidebar-icon-compareb2c="true"
                data-sidebar-icon-copytrip="false"
                data-sidebar-icon-downloadtrip="false"
                data-sidebar-icon-printtrip="false"
                data-sidebar-icon-shares="false"
                data-sidebar-icon-b2b-forward="false"
                data-sidebar-icon-fb="false"
                data-sidebar-icon-line-pc="false"
                data-sidebar-icon-line-m="false"
            />
            <section className="searchPanelWrap">
                <h1>{KEYWORD}相關旅遊搜尋｜雄獅旅遊</h1>
                <div
                    className={cN(
                        'searchPanelContent',
                        sticky === 'searchPanel' ? 'MobileSticky' : ''
                    )}
                >
                    <div
                        className={cN({ searchPanelContent_icon: sticky === 'searchPanel' })}
                        style={{ display: sticky === 'searchPanel' ? '' : 'none' }}
                    >
                        <a href={homePageHref}>
                            <Lion type="lion" color="#f03742" />
                        </a>
                    </div>
                    <div id="searchPanel" />
                    {/*searchPanel 初始標籤*/}
                </div>
            </section>
            <div className="bg_white">
                <main className={`${moduleClass}_content`}>
                    <div className={`${moduleClass}_resultWrap`}>
                        {isMobile ? <FiltersWithSort isSticky={sticky} /> : <FiltersWithSort />}
                    </div>
                </main>
            </div>
            <div className={cN(`${moduleClass}_favPopUp`, { show: favPopUp.show })}>
                <div className={cN('content', { addFav: favPopUp.state === 'addFav' })}>
                    {favPopUp.state === 'addFav' ? (
                        <>
                            <Icons.FillHeart fill="#f03742" width="16" height="16" />
                            <span>已加入收藏</span>
                        </>
                    ) : (
                        <>
                            <Icons.HollowHeart fill="#999" width="16" height="16" />
                            <span>取消收藏</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <Provider store={store}>
            <Search />
        </Provider>
    </React.StrictMode>
);

export default Search;
